import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const SiteSummary = createSlice({
  name: "SiteSummary",
  initialState: {
    sitesTableData: [],
  },
  reducers: {
    ReducerTableData: (state: any, action: any) => {
      state.sitesTableData = action.payload;
      return state;
    },
    ReducerAddTableData: (state: any, action: any) => {
      state.sitesTableData = action.payload;
      return state;
    },
  },
});

export const { ReducerTableData, ReducerAddTableData } = SiteSummary.actions;

export default SiteSummary;
